import * as actionTypes from "../action";

const initialState = {
    subscriptionPlans: [],
    subscriptionPlansLoader: false,
    subscriptionCustomerLoader: false,
    subscriptionCreateLoader: false,
    subscriptionCancelLoader: false,
    subscriptionReactivateLoader: false,
    paymentMethodsLoader: false,
    setDefaultPaymentMethodLoader: false,
    paymentMethods: [],
    stripeCustomer: null,
    activeSubscription: null,
    error: null,
};

const subscriptionReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_SUBSCRIPTION_PLANS_LOADER:
            return { ...state, subscriptionPlansLoader: action.payload };

        case actionTypes.GET_SUBSCRIPTION_PLANS_DATA:
            return { ...state, subscriptionPlans: action.payload };

        case "SUBSCRIPTION_CUSTOMER_LOADER":
            return {
                ...state,
                subscriptionCustomerLoader: action.payload,
            };

        case "SET_STRIPE_CUSTOMER":
            return {
                ...state,
                stripeCustomer: action.payload,
            };

        case "SUBSCRIPTION_CREATE_LOADER":
            return {
                ...state,
                subscriptionCreateLoader: action.payload,
            };

        case "SET_ACTIVE_SUBSCRIPTION":
            return {
                ...state,
                activeSubscription: action.payload,
            };

        case "SUBSCRIPTION_CANCEL_LOADER":
            return { ...state, subscriptionCancelLoader: action.payload };

        case "SUBSCRIPTION_CANCEL_SUCCESS":
            return {
                ...state,
                activeSubscription: action.payload,
                subscriptionCancelLoader: false,
            };

        case "SUBSCRIPTION_REACTIVATE_LOADER":
            return { ...state, subscriptionReactivateLoader: action.payload };

        case "SUBSCRIPTION_REACTIVATE_SUCCESS":
            return {
                ...state,
                activeSubscription: action.payload,
                subscriptionReactivateLoader: false,
            };

        case "PAYMENT_METHODS_LOADER":
            return { ...state, paymentMethodsLoader: action.payload };

        case "PAYMENT_METHODS_SUCCESS":
            return {
                ...state,
                paymentMethods: action.payload,
                paymentMethodsLoader: false,
            };

        case "SET_DEFAULT_PAYMENT_METHOD_LOADER":
            return { ...state, setDefaultPaymentMethodLoader: action.payload };

        case "SET_DEFAULT_PAYMENT_METHOD_SUCCESS":
            return {
                ...state,
                setDefaultPaymentMethodLoader: false,
            };

        case "SUBSCRIPTION_ERROR":
            return {
                ...state,
                error: action.payload,
                subscriptionPlansLoader: false,
                subscriptionCustomerLoader: false,
                subscriptionCreateLoader: false,
                subscriptionCancelLoader: false,
                subscriptionReactivateLoader: false,
                paymentMethodsLoader: false,
                setDefaultPaymentMethodLoader: false,
            };

        default:
            return state;
    }
};

export default subscriptionReducer;
